import { request } from 'utils/ajax';
import { memoize } from 'lodash';
import { Currency } from 'types';

export const getCurrencies = memoize(
    (): Promise<Currency[]> => {
        return request(`api/currency`).then((x) => x.json());
    }
);
